(() => {
  if (window.ecoClickMegaMenusReady) return;
  window.ecoClickMegaMenusReady = true;

  const initClickMegaMenus = (root = document) => {
    const menus = Array.from(root.querySelectorAll('details.mega-menu'));

    if (!menus.length) return;

    const closeMenu = (menu) => {
      const summary = menu.querySelector('summary');

      menu.removeAttribute('open');
      menu.classList.remove('is-open');

      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
        summary.classList.remove('is-active');
      }
    };

    const closeAllMenus = (exceptMenu = null) => {
      document.querySelectorAll('details.mega-menu').forEach((menu) => {
        if (menu !== exceptMenu) closeMenu(menu);
      });
    };

    menus.forEach((menu) => {
      if (menu.dataset.clickMegaReady === 'true') return;

      const summary = menu.querySelector('summary');
      const panel = summary ? summary.nextElementSibling : null;

      if (!summary || !panel) return;

      menu.dataset.clickMegaReady = 'true';
      summary.setAttribute('aria-expanded', menu.hasAttribute('open') ? 'true' : 'false');

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const shouldOpen = !menu.hasAttribute('open');

        closeAllMenus(menu);

        if (shouldOpen) {
          menu.setAttribute('open', '');
          menu.classList.add('is-open');
          summary.setAttribute('aria-expanded', 'true');
          summary.classList.add('is-active');
        } else {
          closeMenu(menu);
        }
      });

      panel.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    });
  };

  const closeAllMegaMenus = () => {
    document.querySelectorAll('details.mega-menu').forEach((menu) => {
      const summary = menu.querySelector('summary');

      menu.removeAttribute('open');
      menu.classList.remove('is-open');

      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
        summary.classList.remove('is-active');
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initClickMegaMenus();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initClickMegaMenus(event.target);
  });

  document.addEventListener('click', () => {
    closeAllMegaMenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllMegaMenus();
  });
})();
